module.exports = __webpack_public_path__ + "media/images/athletes/1375-6ac6a8fab02a8ec653803591f9156fd9.png";